import { useContext } from "react"
import { UploadFlowContext } from "./UploadFlow"

export const useUploadFlowContext = () => {
    const context = useContext(UploadFlowContext)
    return context
}
